export default __webpack_public_path__ + "static/media/20240926-20241015.fdc37d18.png";